<template>
  <div class="wrapper">
    <div class="dot error"></div> <span class="subtitle-1">REC</span>
  </div>
</template>

<script>
  export default {
    name: "RecordDot"
  }
</script>

<style scoped>
  .wrapper{
    padding: 10px;
    position: absolute;
    display: flex;
    justify-content: flex-start;
  }

  .wrapper .subtitle-1{
    margin-top: -0.375rem;
    padding-left:10px;
    padding-right:10px;
  }

  .dot{
    margin: 0;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    animation: shadow-pulse 2s infinite;
  }

  @keyframes shadow-pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
    }
    100% {
      box-shadow: 0 0 0 35px rgba(0, 0, 0, 0);
    }
  }

  @keyframes shadow-pulse-big {
    0% {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
    }
    100% {
      box-shadow: 0 0 0 70px rgba(0, 0, 0, 0);
    }
  }


</style>